// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {
  NavBar,
  Tabbar,
  TabbarItem,
  Icon,
  Swipe,
  SwipeItem,
  Cell,
  CellGroup,
  Button,
  Tab,
  Tabs,
  Panel,
  Field,
  Dialog,
  Loading,
  AddressList,
  AddressEdit,
  Row,
  Col,
  SubmitBar,
  RadioGroup,
  Radio,
  SwitchCell,
  Popup,
  Picker,
  Rate,
  Uploader,
  DatetimePicker,
  Area
} from 'vant'
import 'lib-flexible/flexible'
import '@/styles/iconfont.css'
import '@/permission'
import check from '@/const/check'
import resource from '@/utils/resource'
// import '@/utils/vconsoleUtil'

import VueScroller from 'vue-scroller'
window.$check = check
window.$store = store
window.resource = resource
Vue.use(VueScroller)
Vue.use(NavBar).use(Tabbar).use(TabbarItem).use(Icon).use(Swipe).use(SwipeItem).use(Cell).use(CellGroup).use(Button).use(Tab).use(Tabs).use(Panel).use(Field).use(Dialog).use(Loading).use(AddressList).use(AddressEdit).use(Col).use(Row).use(SubmitBar).use(RadioGroup).use(Radio).use(SwitchCell).use(Popup).use(Picker).use(Rate).use(Uploader).use(DatetimePicker).use(Area)
Vue.config.productionTip = false // permission control
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: {
    eventHub: new Vue()
  },
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js